import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from "./AdminSidebar.module.css";
import {
  HomeIcon,
  FolderIcon,
  NewspaperIcon,
  EnvelopeIcon,
  UserGroupIcon,
  ArrowLeftOnRectangleIcon 
} from "@heroicons/react/24/solid";
import { MdRequestQuote } from "react-icons/md";
import { BsFillPeopleFill } from "react-icons/bs";

// --- Importaciones Nuevas ---
import ConfirmModal from '../common/ConfirmModal';
import { useConfirm } from '../../hooks/useConfirm';
// ---------------------------

interface SidebarProps {
  onToggle: (isOpen: boolean) => void;
}

const Sidebar: React.FC<SidebarProps> = ({ onToggle }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [userName, setUserName] = useState('Usuario');
  const navigate = useNavigate();
  
  // --- Hook de Confirmación ---
  const { isOpen: isConfirmOpen, config, confirm, handleConfirm, handleCancel } = useConfirm();

  useEffect(() => {
    const storedName = localStorage.getItem('userName');
    if (storedName) {
      setUserName(storedName);
    }
  }, []);

  const handleMouseEnter = () => {
    setIsOpen(true);
    onToggle(true);
  };

  const handleMouseLeave = () => {
    setIsOpen(false);
    onToggle(false);
  };

  // --- Función Logout Actualizada ---
  const handleLogout = async () => {
    // Usamos el modal personalizado en lugar de window.confirm
    const isConfirmed = await confirm({
      title: 'Cerrar Sesión',
      message: '¿Estás seguro de que deseas salir del sistema?',
      confirmText: 'Salir',
      cancelText: 'Cancelar',
      type: 'warning' // Usamos 'warning' o 'info' para que no sea rojo agresivo
    });

    if (isConfirmed) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('userName');
        localStorage.removeItem('userEmail');
        localStorage.removeItem('userRole');
        navigate('/login');
    }
  };

  return (
    <>
      <div
        className={`${styles.sidebar} ${isOpen ? styles.open : styles.closed}`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className={styles.profile}>
          <div className={`${styles.avatar} ${!isOpen ? styles.avatarClosed : ''}`}>
               <span style={{display:'flex', justifyContent:'center', alignItems:'center', height:'100%', color:'white', fontSize:'1.5rem'}}>
                  {userName.charAt(0).toUpperCase()}
               </span>
          </div>
          {isOpen && <p className={styles.name}>{userName}</p>}
        </div>
        
        <nav className={styles.nav}>
          <Link to="/dashboard" className={styles.navItem}>
            <HomeIcon className={styles.icon} />
            <span className={styles.navText}>Dashboard</span>
          </Link>
          <Link to="/projects" className={styles.navItem}>
            <FolderIcon className={styles.icon} />
            <span className={styles.navText}>Proyectos</span>
          </Link>
          <Link to="/articles" className={styles.navItem}>
            <NewspaperIcon className={styles.icon} />
            <span className={styles.navText}>Artículos y Noticias</span>
          </Link>
          <Link to="/messages" className={styles.navItem}>
            <EnvelopeIcon className={styles.icon} />
            <span className={styles.navText}>Mensajes</span>
          </Link>
          <Link to="/quotes" className={styles.navItem}>
            <MdRequestQuote className={styles.icon} />
            <span className={styles.navText}>Cotizaciones</span>
          </Link>
          <Link to="/team" className={styles.navItem}>
            <BsFillPeopleFill className={styles.icon} />
            <span className={styles.navText}>Miembros del equipo</span>
          </Link>
          <Link to="/users" className={styles.navItem}>
              <UserGroupIcon className={styles.icon} />
              <span className={styles.navText}>Usuarios</span>
          </Link>

          <button 
              onClick={handleLogout} 
              className={styles.navItem} 
              style={{background:'transparent', border:'none', width:'100%', cursor:'pointer', marginTop:'auto', borderTop:'1px solid #374151'}}
          >
              <ArrowLeftOnRectangleIcon className={styles.icon} style={{color: '#ef4444'}} />
              <span className={styles.navText} style={{color: '#ef4444'}}>Cerrar Sesión</span>
          </button>
        </nav>
      </div>

      {/* --- Renderizamos el Modal Aquí --- */}
      <ConfirmModal
        isOpen={isConfirmOpen}
        title={config?.title || ''}
        message={config?.message || ''}
        confirmText={config?.confirmText}
        cancelText={config?.cancelText}
        type={config?.type}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    </>
  );
}

export default Sidebar;